import React, { useState, useEffect } from 'react';
import { Button, Input, Checkbox, Message } from '@arco-design/web-react';
import pluginService from '../../services/pluginService';
// ================== 组件主体 ==================
export default function HomeToolbar({ pluginDetected }) {
   // ========== 1. 本地状态 ==========
  const [keyword, setKeyword] = useState('');
  const [isDouyinChecked, setIsDouyinChecked] = useState(true);
  const [isXiaohongshuChecked, setIsXiaohongshuChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pluginInitialized, setPluginInitialized] = useState(false);
  // ========== 2. 副作用：初始化插件 ==========
  useEffect(() => {
    const initPlugin = async () => {
      try {
        if (typeof chrome !== 'undefined' && chrome.runtime) {
          await pluginService.initialize();         
          // 自动设置用户提供的插件ID
          const userExtensionId = 'dfbdabjinopkojmnjhjkdakmkefdbbnm';
          try {
            pluginService.setExtensionId(userExtensionId);
            setPluginInitialized(true);
    
          } catch (error) {
    
            setPluginInitialized(false);
          }          
    
        } else {
    
          setPluginInitialized(false);
        }
      } catch (error) {
  
        setPluginInitialized(false);
        // 即使插件初始化失败，也不阻止应用运行
        Message.warning('插件未连接，部分功能可能不可用');
      }
    };
    initPlugin();
  }, []);
// 插件初始化后，设置全局标记
useEffect(() => {
  if (pluginInitialized) {
    window.__MY_PLUGIN_INSTALLED__ = true;
  }
}, [pluginInitialized]);
  // 手动设置扩展ID
  const setExtensionId = () => {
    const extensionId = prompt(
      '请输入插件扩展ID\n\n' +
      '获取方法：\n' +
      '1. 打开Chrome浏览器\n' +
      '2. 在地址栏输入：chrome://extensions/\n' +
      '3. 找到"智能评论收集工具"扩展\n' +
      '4. 点击"详情"\n' +
      '5. 复制"扩展程序ID"（一串字母数字组合）\n\n' +
      '请输入扩展ID：'
    );
    if (extensionId && extensionId.trim()) {
      try {
        pluginService.setExtensionId(extensionId.trim());
        setPluginInitialized(true);
        Message.success('扩展ID设置成功，插件已连接！');
      } catch (error) {
        Message.error('设置扩展ID失败：' + error.message);
      }
    } else if (extensionId !== null) {
      Message.warning('请输入有效的扩展ID');
    }
  };
// ========== 3. 事件处理函数 ==========
  // 检查插件状态
  const checkPluginStatus = async () => {
    try {
      // 检查Chrome扩展环境
      if (typeof chrome === 'undefined' || !chrome.runtime) {
        return { available: false, message: '请在Chrome浏览器中安装插件后使用' };
      }
      // 检查插件是否已初始化
      if (!pluginInitialized) {
        return { available: false, message: '插件未初始化，请刷新页面重试' };
      }
      // 尝试获取插件状态
      const status = pluginService.getStatus();
      if (!status.isConnected || !status.extensionId) {
        return { available: false, message: '插件连接失败，请检查插件是否正确安装' };
      }
      return { available: true };
    } catch (error) {

      return { available: false, message: '插件状态检查失败，请重新安装插件' };
    }
  };

  // 处理搜索
  const handleSearch = async () => {
    if (!keyword.trim()) {
      Message.error('请输入关键词');
      return;
    }

    if (!isDouyinChecked && !isXiaohongshuChecked) {
      Message.error('请至少选择一个平台');
      return;
    }

    // 检查插件状态
    const pluginStatus = await checkPluginStatus();
    if (!pluginStatus.available) {
      Message.error(pluginStatus.message);
      return;
    }

    setLoading(true);
    try {
      // 处理选中的平台
      const platforms = [];
      if (isDouyinChecked) platforms.push('抖音');
      if (isXiaohongshuChecked) platforms.push('小红书');

      // 跳转到对应平台
      for (const platform of platforms) {
        try {
          await pluginService.openSearch(keyword, platform, 'true');
          Message.success(`已打开${platform}搜索链接`);
        } catch (error) {
  
          Message.error(`打开${platform}搜索失败，请检查插件状态`);
        }
      }
    } catch (error) {

      Message.error('搜索失败，请检查插件状态');
    } finally {
      setLoading(false);
    }
  };
 // 回车触发搜索
 const handleKeyPress = (e) => {
  if (e.key === 'Enter') {
    handleSearch();
  }
};
        // 调试插件状态
        const debugPlugin = async () => {

          
          if (typeof chrome !== 'undefined' && chrome.runtime) {
            try {
              const status = pluginService.getStatus();

              
              // 尝试获取扩展信息
              if (chrome.management) {
                chrome.management.getAll((extensions) => {

                  const targetExtension = extensions?.find(ext => 
                    ext.name === '智能评论收集工具' || 
                    ext.name.includes('评论收集') ||
                    ext.name.includes('内容收集')
                  );

                });
              }
            } catch (error) {

            }
          }
          
          Message.info('调试信息已输出到控制台，请按F12查看');
        };
 return (
       <div style={{ display: 'flex', alignItems: 'center', marginBottom: 130,  marginTop: 140,justifyContent: 'center' }}>
        <Input 
          placeholder="输入关键词可用逗号分隔，如：广州,招聘" 
          style={{ width: 'auto', minWidth: 120, maxWidth: 600, flex: 1, marginLeft: 24 }}
          value={keyword}
          onChange={setKeyword}
          onKeyPress={handleKeyPress}
        />
        <Button 
          type="primary" 
          style={{ marginLeft: 8 }}
          onClick={handleSearch}
          loading={loading}
        >
          搜索
        </Button>

        {/* 只有未检测到插件时才显示复选框 */}
        {!pluginDetected && (
          <>
            <Checkbox 
              style={{ marginLeft: 16 }}
              checked={isDouyinChecked}
              onChange={setIsDouyinChecked}
            >
              抖音
            </Checkbox>
            <Checkbox 
              style={{ marginLeft: 8 }}
              checked={isXiaohongshuChecked}
              onChange={setIsXiaohongshuChecked}
            >
              小红书
            </Checkbox>
          </>
        )}

        {/* 插件状态指示器始终显示 */}
        <div style={{ 
          marginLeft: 16, 
          display: 'flex', 
          alignItems: 'center',
          fontSize: 12,
          color: pluginInitialized ? '#52c41a' : '#ff4d4f'
        }}>
          <div style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: pluginInitialized ? '#52c41a' : '#ff4d4f',
            marginRight: 4
          }}></div>
          {pluginInitialized ? '插件已连接' : '插件未连接'}
        </div>
        {/* 只有未检测到插件时才显示调试按钮 */}
        {!pluginDetected && (
          <Button 
            size="small"
            style={{ marginLeft: 8 }}
            onClick={debugPlugin}
          >
            调试
          </Button>
        )}
            </div>
          );
        }